import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import usePageTitle from 'hooks/usePageTitle';


import Breadcrumbs from './components/Breadcrumbs';
import RepairSummary from './components/RepairSummary';
import Logs from './components/Logs';
import RepairsList from './components/RepairsList';

function OperationRepairsView({ edit }) {
    const { id } = useParams();
    const [setPageTitle] = usePageTitle('Operations');
    useEffect(() => {
        return () => {
            setPageTitle(null);
        };
    }, []);
    
    
    const [operationDetails, setOperationDetails] = useState({
        id: '',
        referenceNo: '',
        status: '',
        action: '',
        type: '',
        isCompleted: false,
        products: [],
        logs: []
    });

    const [repairsLists, setRepairsLists] = useState([]);

    useEffect(() => {
        if (id) {
            initializeOperationDetails();
        }
    }, []);

    const initializeOperationDetails = () => {

        api.getOperationItemRepairs(id).then((res) => {
            if (res?.status) {
                setRepairsLists(res?.data);
            }
        });
    }



    const handleRemoveProductFromList = (index) => {
        const updatedProducts = operationDetails?.products ? [...operationDetails.products] : [];

        updatedProducts.splice(index, 1);
        setOperationDetails({
            ...operationDetails,
            
            products: updatedProducts
        });
    }



    const handleReloadData = () => {
        initializeOperationDetails();
    }

	return (
        <div className="row m-0 w-100" style={{ marginTop: '20px' }}>
            <div className="col-12 col-md-12">
                <div className="section-head" style={{ paddingLeft: '0' }}>
                    
                    <h2>
                        <div className="actions" style={{ display: 'flex', width: '100%' }}>

                            <Breadcrumbs
                                current={`repairs`}
                                activateTabsUsingId={repairsLists?.id}
                                referenceNumber={repairsLists?.reference_number}
                                isCompleted={repairsLists?.is_completed ? true : false}
                            />

                        </div>
                    </h2>
                    <div className="actions">
                    </div>
                </div>
                <div className="row m-0">
                    <div className="col-lg-9 p-0 form-group" style={{ marginTop: '5px' }}>
                        <div className="card shadow-sm bg-white table-card p-3" style={{ marginTop: '0' }}>
                            <div className="bg-white pt-0" style={{  marginTop: '-15px' }}>
                            
                                <div className="row">
                                    <div className="col-12">
                                        
                                        <RepairsList
                                            repairsLists={repairsLists}
                                            handleReloadData={handleReloadData}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                    <div className="col-lg-3">
                        <div className="row">
                            <div className="col-12 form-group">
                                <RepairSummary
                                    repairsLists={repairsLists}
                                />
                                <Logs
                                    logs={repairsLists?.logs}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	);
}

export default OperationRepairsView;
